export default __webpack_public_path__ + "static/media/pin.60dc219d.svg";